import * as Yup from "yup";
import {withFormik} from "formik";
import moment from "moment";

export default withFormik({
  mapPropsToValues: ({ values }: any) => values,
  validationSchema: ({}) =>
    Yup.object().shape({
      code: Yup.string()
        .nullable()
        .test('code', 'Nhập đầy đủ mã xác minh.'.t(), function () {
          let { code, level } = this.parent;
          code = (code || ``).replace(/[^\w]/g, '');
          return (level > 1 && `${code}`.length === 6 );
        })
    }),
  handleSubmit: async ({ level, displayName, sex, code, auth, birthday, phone, ...values}, { props }) => {
    let { setRegisterValues } = props;
    let { doLogin, onRegister, confirmationResult, setConfirmationResult } = props;

    code = (code || ``).replace(/[^\w]/g, '');
    const { day, month, year } = birthday || {};
    try {
      confirmationResult
        .confirm(code)
        .then(({ user: { uid, refreshToken, phoneNumber: phone } }) => {
          if (uid && refreshToken) {
            auth = auth.filter(({ providerId }) => providerId !== 'phone');
            auth.push({ uid, token: refreshToken, providerId: 'phone' });
            /** user birthday */
            if (day && month && year) { birthday = moment(`${year}-${month}-${day}`); }

            onRegister({ ...values, auth, phone, profile: { displayName, sex, birthday } })
              .then(async ({ entity: { session: variables } }) => {
                await setRegisterValues(values, 0);
                await setConfirmationResult(null);
                await doLogin(variables);
              })
              .catch(errorCatch);
          }
        })
        .catch(errorCatch);
    } catch (e) {
      errorCatch(e);
    }
  },
  enableReinitialize: true,
  displayName: 'RegisterForm', // helps with React DevTools
});
